import { createContext, useContext, useEffect, useState } from "react";
import { ContextProviderProps, RequiredAccomplishment } from "./interfaces";
import { useUserContext } from "./UserContext";
import "react-toastify/dist/ReactToastify.css";
import { getRequiredAccomplishments } from "../scripts/dataHandlers";
import { useErrorContext } from "./ErrorContext";

interface RequiredAccomplishmentsContextType {
  requiredAccomplishments: RequiredAccomplishment[] | undefined;
  setRequiredAccomplishments: (
    val: RequiredAccomplishment[] | undefined
  ) => void;
}

export const RequiredAccomplishmentsContext = createContext(
  {} as RequiredAccomplishmentsContextType
);
export const useRequiredAccomplishmentsContext = () =>
  useContext(RequiredAccomplishmentsContext);

export const RequiredAccomplishmentsContextProvider = ({
  children,
}: ContextProviderProps) => {
  const { user } = useUserContext();

  const { handleError } = useErrorContext();

  const [requiredAccomplishments, setRequiredAccomplishments] =
    useState<RequiredAccomplishment[]>();

  // UseEffect function which gets required accomplishments from backend
  useEffect(() => {
    const getRequiredAccData = async () => {
      const res = user && (await getRequiredAccomplishments(user.id));
      if (res?.status === 200) {
        console.log("Res in getRequiredAccData: ", res);
        setRequiredAccomplishments(res.data.result);
      } else {
        handleError(res, "GetRequiredAccomplishmentsFailed");
      }
    };
    user && getRequiredAccData();
  }, [user]);

  return (
    <RequiredAccomplishmentsContext.Provider
      value={{ requiredAccomplishments, setRequiredAccomplishments }}
    >
      {children}
    </RequiredAccomplishmentsContext.Provider>
  );
};
